import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const CenteredContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.background.paper,
  width: '100%',
  textAlign: 'center',
  marginTop: theme.spacing(2),
}));

const LightsComponent = ({ Icon, label, onBackToMenu }) => {
  const [enabled, setEnabled] = useState(false);

  const toggleEnabled = () => {
    setEnabled(!enabled);
  };

  return (
    <CenteredContainer elevation={4}>
      <IconButton color={enabled ? 'primary' : 'default'} onClick={toggleEnabled}>
        <Icon size={50} />
      </IconButton>
      <Typography variant="body1">
        {label}
      </Typography>
      <Typography variant="caption">
        Click the button to {enabled ? 'disable' : 'enable'}
      </Typography>
      <Button variant="contained" color="primary" onClick={onBackToMenu} style={{ marginTop: 20 }}>
        Back to Main Menu
      </Button>
    </CenteredContainer>
  );
};

export default LightsComponent;
